import { mapCollection, sortByString } from '../../utils/collection.utils';
import { InternalPresetting } from '../internal-presetting';

export class InternalPresettingBuilder {
  static fromJson(json) {
    return (json)
      ? new InternalPresetting(
        json.hash,
        json.name,
        json.code,
        json.active
      )
      : null;
  }

  static fromList(list) {
    return sortByString('name', mapCollection(InternalPresettingBuilder.fromJson, list));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/internal-presetting.builder.ts